import type {FieldTypeId, Sorting} from 'src/typings';
import type {FilterFieldTypeId, SortFieldTypeId} from './types';
import {mapFieldTypeIdToDynamicFieldSearchParamName} from 'shared/utils/record-field-utils';

export function mapFieldTypeIdToFilterField(fieldTypeId: FieldTypeId, type: 'link' | 'origin' | 'val'): FilterFieldTypeId {
    return mapFieldTypeIdToDynamicFieldSearchParamName(fieldTypeId, type) as FilterFieldTypeId;
}

export function mapFieldTypeIdToSortField(fieldTypeId: FieldTypeId): SortFieldTypeId {
    return mapFieldTypeIdToDynamicFieldSearchParamName(fieldTypeId, 'sort') as SortFieldTypeId;
}

export function createSortingFromName(sorterName: string, type: 'asc' | 'desc'): Sorting {
    return {
        id: `${type === 'asc' ? '' : '-'}${sorterName}`,
        text: sorterName,
        field: sorterName,
        asc: type === 'asc'
    };
}